import { createContext, useContext } from "react";

/**
 * CodeBlockSaveContext — provides per-message save metadata to CodeBlock components.
 *
 * Value shape:
 *   answerId     — Firestore ID of the current answer document being rendered
 *   chatOwnerId  — user_id of the chat owner (space.owner_id for Spectra, current user for personal)
 *   rawContent   — full answer text (for codeblock-index resolution during edits)
 *   isStreaming  — true while the parent message is actively streaming. Used by
 *                  CodeBlock to suppress mid-stream viz rendering.
 */
const CodeBlockSaveContext = createContext({
  answerId: null,
  chatOwnerId: null,
  rawContent: null,
  isStreaming: false,
});

export const useCodeBlockSave = () => useContext(CodeBlockSaveContext);

export default CodeBlockSaveContext;
